// Constants shared across the tag bundle. Centralising them keeps the
// minified output deterministic and trims duplicate string literals.

export const VERSION = "0.1.5";

export const SCRIPT_KEY_ATTR = "data-adpluga-key";
export const SCRIPT_BASE_ATTR = "data-adpluga-base";

export const SLOT_ATTR = "data-adpluga-slot";
export const FORMAT_ATTR = "data-adpluga-format";
export const REFRESH_ATTR = "data-adpluga-refresh";
export const LAZY_ATTR = "data-adpluga-lazy";
export const TEST_ATTR = "data-adpluga-test";

export const STORAGE_KEY = "adpluga_uid";

// DEFAULT_BASE is used when no `data-adpluga-base` is set on the script tag:
// the edge, absolute, because the tag runs on the publisher's page and a
// relative base resolves against the publisher's own domain. It was "/v1/",
// so the documented one-line snippet called <publisher>/v1/serve and never
// filled. Same default as the web SDK. The trailing slash matters: paths are
// concatenated, not URL-joined.
export const DEFAULT_BASE = "https://edge.adpluga.com/v1/";

// IAB-aligned viewability: 50% of the pixels visible for at least 1s.
export const VIEWABILITY_THRESHOLD = 0.5;
export const VIEWABILITY_DURATION_MS = 1000;

// Lazy slots start fetching when within this margin of the viewport.
export const LAZY_ROOT_MARGIN = "200px";

// A cadence below the floor is raised to it, never dropped, so a slot always
// keeps rotating. Live traffic honours the 30s industry minimum; sandbox keys
// may rotate every 15s so an integrator can watch it work without waiting.
export const MIN_REFRESH_SECS = 30;
export const MIN_REFRESH_SECS_TEST = 15;
